import { ShieldCheck, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
    const year = new Date().getFullYear();

    return (
        <footer className="border-t border-[#E2E8F0] bg-white" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 md:py-16">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    {/* Brand block */}
                    <div className="md:col-span-5">
                        <Link to="/" className="inline-flex items-center gap-2.5 group" data-testid="footer-logo">
                            <div className="h-10 w-10 rounded-xl bg-[#064E3B] flex items-center justify-center shadow-[0_4px_12px_rgba(6,78,59,0.25)] group-hover:scale-105 transition-transform">
                                <ShieldCheck className="w-5 h-5 text-white" />
                            </div>
                            <div className="flex flex-col leading-none">
                                <span className="font-display font-semibold text-[#022C22] text-lg">SINPE-Flow</span>
                                <span className="text-[10px] uppercase tracking-widest text-[#64748B] mt-0.5">Pagos verificados</span>
                            </div>
                        </Link>
                        <p className="text-sm text-[#334155] mt-5 max-w-sm leading-relaxed">
                            La forma más segura de aceptar pagos SINPE Móvil en Costa Rica. Verificación automática, cero capturas falsas, control total para tu negocio.
                        </p>
                    </div>

                    {/* Product links */}
                    <div className="md:col-span-3">
                        <p className="text-xs uppercase tracking-widest text-[#64748B] font-medium mb-4">Producto</p>
                        <ul className="space-y-2.5 text-sm text-[#334155]">
                            <li><Link to="/" className="hover:text-[#064E3B] transition-colors" data-testid="footer-link-features">Cómo funciona</Link></li>
                            <li><Link to="/" className="hover:text-[#064E3B] transition-colors" data-testid="footer-link-pricing">Beneficios</Link></li>
                            <li><Link to="/dashboard" className="hover:text-[#064E3B] transition-colors" data-testid="footer-link-dashboard">Dashboard</Link></li>
                        </ul>
                    </div>

                    {/* Company links */}
                    <div className="md:col-span-2">
                        <p className="text-xs uppercase tracking-widest text-[#64748B] font-medium mb-4">Legal</p>
                        <ul className="space-y-2.5 text-sm text-[#334155]">
                            <li><Link to="/terminos" className="hover:text-[#064E3B] transition-colors" data-testid="terms-link">Términos</Link></li>
                            <li><Link to="/terminos" className="hover:text-[#064E3B] transition-colors" data-testid="privacy-link">Privacidad</Link></li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div className="md:col-span-2">
                        <p className="text-xs uppercase tracking-widest text-[#64748B] font-medium mb-4">Contacto</p>
                        <ul className="space-y-2.5 text-sm text-[#334155]">
                            <li className="flex items-center gap-2">
                                <Mail className="w-3.5 h-3.5 text-[#64748B] flex-shrink-0" />
                                <span className="font-mono text-xs">hola@sinpeflow.com</span>
                            </li>
                            <li className="flex items-center gap-2">
                                <MapPin className="w-3.5 h-3.5 text-[#64748B] flex-shrink-0" />
                                <span>San José, Costa Rica</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="border-t border-[#E2E8F0] bg-[#F8FAFC]">
                <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#64748B]">
                    <p data-testid="footer-copyright">
                        <span className="font-medium text-[#022C22]">&copy; {year} SINPE-Flow Costa Rica.</span>{" "}
                        Verificación de pagos inteligente.
                    </p>
                    <div className="flex items-center gap-2">
                        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-white border border-[#E2E8F0]">
                            <span className="h-1.5 w-1.5 rounded-full bg-[#10B981] animate-pulse" />
                            Sistema operando con normalidad
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
